import React, { forwardRef, useImperativeHandle } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Button, DatePicker, Form, Input, InputNumber, Select } from 'antd'
import { Col, Grid, Row } from 'react-flexbox-grid'
import * as Constants from '../../../constants'

const { Option } = Select

const FormReportWorkOrder = forwardRef((props, ref) => {
    const { loading, onSubmitReportWorkOrder, workOrderToEdit } = props
    const [form] = Form.useForm()

    useImperativeHandle(ref, () => ({
        resetReport () {
            form.resetFields()
        }
    }))

    const clearReport = () => {
        form.resetFields()
    }

    const handleSubmit = values => {
        const items = workOrderToEdit && (workOrderToEdit.selectedItems || workOrderToEdit.items) ? (workOrderToEdit.selectedItems || workOrderToEdit.items) : []
        if (items.length === 0) {
            return
        }
        
        const report = {
            reportDate: values.reportDate ? moment(values.reportDate).format('DD/MM/YYYY') : '',
            taskDone: values.taskDone !== undefined ? values.taskDone : '',
            reportCompletionPercentage: values.reportCompletionPercentage !== undefined ? values.reportCompletionPercentage : 0,
            itemId: values.itemId,
            message: values.message !== undefined ? values.message : ''
        }
        onSubmitReportWorkOrder(report)
    }

    const items = workOrderToEdit && (workOrderToEdit.selectedItems || workOrderToEdit.items) ? (workOrderToEdit.selectedItems || workOrderToEdit.items) : []
    const hasItems = items.length > 0

    return (
        <Grid>
            <Form onFinish={handleSubmit} form={form} initialValues={{
                reportDate: moment()
            }}>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Item name="reportDate">
                            <DatePicker format={'DD/MM/YYYY'} placeholder="Fecha informe" style={{ width: '100%' }}/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Item name="taskDone"
                            rules={[{ required: true, message: 'Ingrese la tarea realizada' }]}>
                            <Input placeholder="Tarea realizada"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Item name="reportCompletionPercentage"
                            rules={[{ required: true, message: 'Ingrese el estimado de avance' }]}>
                            <InputNumber
                                style={{ width: '100%' }}
                                placeholder="Estimado de avance"
                                min={0}
                                max={100}
                                formatter={value => `${value}%`}
                                parser={value => value.replace('%', '')}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Item name="itemId"
                            rules={[{ required: true, message: 'Seleccione un item' }]}>
                            <Select placeholder="Item" disabled={!hasItems}>
                                {
                                    hasItems && items.map(item =>
                                        <Option key={item.id} value={item.id}>{item.name}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={12} md={6}>
                        <Form.Item name="message">
                            <Input placeholder="Mensaje"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={6}>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button type="primary" htmlType="submit" loading={loading} disabled={!hasItems}>
                                Cargar
                            </Button>
                        </Form.Item>
                    </Col>
                    <Col xs={6}>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button onClick={clearReport} loading={loading} disabled={!hasItems}>
                                Limpiar
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
                {!hasItems && (
                    <Row center="xs">
                        <Col xs={12}>
                            <h3 style={{ color: 'red' }}>Esta orden de trabajo no tiene items seleccionados. No se pueden crear reportes de avance.</h3>
                        </Col>
                    </Row>
                )}
                <Row center="xs">
                    <Col xs={12}>
                        <h3><span style={{ fontWeight: 'bold' }}>Nota:</span> El porcentaje ingresado del item se tomará como final. Es decir, no es acumulativo. Por lo tanto, el ultimo porcentaje de avance detectado por item será el que se tome en cuenta para la suma parcial del cálculo de avance total de la OT.</h3>
                    </Col>
                </Row>
            </Form>
        </Grid>
    )
})

FormReportWorkOrder.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSubmitReportWorkOrder: PropTypes.func.isRequired
}

export default FormReportWorkOrder
